import React, { useRef, useState } from "react";
import editPen from "../../../assets/svg/pen.svg";
import linkIcon from "../../../assets/svg/linkicon.svg";
import useOnClickOutside from "../../../hooks/useClickOutside";
import { useRecoilValue } from "recoil";
import { MainAppSideBarExpandAtom } from "../../../atom";
import HipchatChevronDownIcon from "../../../assets/HipchatChevronDownIcon";
import { motion } from "framer-motion";
import EyeIcon from "../../../assets/svg-tsx/EyeIcon";
import { useNavigate } from "react-router-dom";
import { checkPermissions } from "../../../utils/helper";
import { Tooltip } from "antd";

const OrderCreateUserDetails = ({
  userData,
  orderDetails,
  formatDate,
}: any) => {
  const navigate = useNavigate();
  const statusOptions = [
    { value: "ONGOING", label: "ONGOING" },
    { value: "COMPLETED", label: "COMPLETED" },
  ];
  const [selected, setSelected] = useState<any>(null);
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  // Permission
  const hasEditPermission = checkPermissions("view_customer");

  useOnClickOutside(selectRef, () => setIsOpen(false));

  const handleOptionClick = (option: any) => {
    setSelected(option);
    setIsOpen(false);
  };

  return (
    <div className="text-start px-4 pt-2 py-4 h-full">
      <div className="w-full flex justify-between">
        <h1 className="text-pot-yellow font-medium text-sm">
          Customer Details:{" "}
        </h1>
        {/* Added eye icon which will redirect to the edit customer page */}
        {userData?.id && (
          <Tooltip
            title={
              !hasEditPermission &&
              "You don't have permission to perform this action" ||
              "View Details"
            }
            className={`${!hasEditPermission && " opacity-30 "}`}
          >
            <button
              className="mr-2 flex justify-center items-center cursor-pointer"
              onClick={() => navigate(`/customers/${userData?.id}`)}
              disabled={!hasEditPermission}
            >
              <EyeIcon size="16" />
            </button>
          </Tooltip>
        )}
      </div>
      <div className="flex flex-col space-y-1  text-start mt-2 text-[12px] leading-5">
        <div>
          <p className="text-[#AEAEAE]">Name:</p>
          <p>
            {userData?.name !== undefined && userData?.name !== ""
              ? userData?.name
              : "-"}
          </p>
        </div>
        <div>
          <p className="text-[#AEAEAE]">Date:</p>
          <p>
            {userData?.date_joined
              ? formatDate(userData?.date_joined, "date")
              : "-"}
          </p>
        </div>
        <div>
          <p className="text-[#AEAEAE]">Contact number:</p>
          <p>
            {userData?.phone !== undefined && userData?.phone !== ""
              ? userData?.phone
              : "-"}
          </p>
        </div>
        <div>
          {orderDetails?.address_billing && (
            <div>
              <p className="text-[#AEAEAE]">Location:</p>
              <span>
                {`${orderDetails?.address_billing?.street_1}, ${orderDetails?.address_billing?.city}, ${orderDetails?.address_billing?.state}, ${orderDetails?.address_billing?.postal_code}`}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderCreateUserDetails;
